// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"379ee847","239":"4a39aabf","453":"cc7fa2c5","553":"413e2a7c"}[chunkId] + ".chunk.js";
};